import { connect } from 'react-redux'

import ProfileDrawer from '../components/ProfileDrawer'
import { onLogout } from '../../../store/authentication'
import { pushLocation } from '../../../store/location'
import { toggleProfile } from '../../../store/global'

const mapStateToProps = state => ({ ...state.authentication })

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLogout() {
    dispatch(onLogout())
    !ownProps.docked && dispatch(toggleProfile(false))
  },
  onViewProfile(profileId) {
    return function() {
      dispatch(pushLocation(`/profile/${profileId}`))
      !ownProps.docked && dispatch(toggleProfile(false))
    }
  },
  onChangePassword(profileId) {
    return function() {
      dispatch(pushLocation(`/change-password/${profileId}`))
      !ownProps.docked && dispatch(toggleProfile(false))
    }
  },
  onAddNews() {
    return function() {
      dispatch(pushLocation(`/news/updateArticles/`))
      !ownProps.docked && dispatch(toggleProfile(false))
    }
  },
  onListNews(profileId = '') {
    return function() {
      dispatch(pushLocation(`/news-article/list/?profileId=${profileId}`))
      !ownProps.docked && dispatch(toggleProfile(false))
    }
  }
})

const ProfileDrawerContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProfileDrawer
)

export default ProfileDrawerContainer



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/containers/ProfileDrawer.js